import { render } from "./PuzzleSolved.vue?vue&type=template&id=4ac8d271&scoped=true&ts=true"
import script from "./PuzzleSolved.vue?vue&type=script&lang=ts"
export * from "./PuzzleSolved.vue?vue&type=script&lang=ts"

import "./PuzzleSolved.vue?vue&type=style&index=0&id=4ac8d271&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac8d271"]])

export default __exports__